import * as React from 'react';
import { supportReactNodeInterpolation } from './interpolation';
// Global I18n instance
var i18nInstance = null;
// Getter and Setter
export function setI18n(instance) {
    // Intl plugin 内部会调用 init，会设置 instance
    i18nInstance = instance;
}
export function getI18n() {
    return i18nInstance;
}
// Context
export var I18nContext = React.createContext({
    i18n: undefined,
    locale: undefined
});
// Starling Intl Plugin
export var registerReactInstance = {
    type: 'intl3rdParty',
    init: function (instance) {
        setI18n(instance);
        // React DOM 插值支持
        supportReactNodeInterpolation(instance);
    }
};
// default i18n Options
var defaultOptions = {
    bindI18n: 'languageChanged loaded initialized',
    bindI18nStore: 'added',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
    useSuspense: true
};
export function getDefaults() {
    return defaultOptions;
}
//# sourceMappingURL=context.js.map